module.exports = __webpack_public_path__ + "img/onboarding3.d4b93b1f.png";